import { Geo, type GeoInput, type GeoInputAsync } from "@rogoag/geo";

export async function toGeoJSONFile(data: GeoInputAsync, filename: string, filePath?: string): Promise<File> {
	const fc = data instanceof Blob ? await Geo.toGeoJSON(data, filePath) : Geo.toGeoJSON(data as GeoInput, filePath);
	return new File([JSON.stringify(fc)], filename, { type: "application/geo+json" });
}

export async function toKMLFile(data: GeoInputAsync, filename: string, filePath?: string): Promise<File> {
	const kml = data instanceof Blob ? await Geo.toKML(data, filePath) : Geo.toKML(data as GeoInput, filePath);
	return new File([kml], filename, { type: "application/vnd.google-earth.kml+xml" });
}

export async function toKMZFile(data: GeoInputAsync, filename: string, filePath?: string): Promise<File> {
	const buf = data instanceof Blob ? await Geo.toKMZ(data, filePath) : Geo.toKMZ(data as GeoInput, filePath);
	return new File([buf], filename, { type: "application/vnd.google-earth.kmz" });
}

export async function toSHPFile(data: GeoInputAsync, filename: string, filePath?: string): Promise<File> {
	const buf = data instanceof Blob ? await Geo.toSHP(data, filePath) : Geo.toSHP(data as GeoInput, filePath);
	return new File([buf], filename, { type: "application/zip" });
}
